export default function AboutUsContent() {
  return (
    <>
      Life Technologies is a wholly owned subsidiary of OnePIN, Inc., a global
      leader in mobile engagement solutions. At Life Technologies, we are
      dedicated to helping people stay meaningfully connected through our
      flagship service, Life — a patent- protected contact exchange platform
      that makes it simple for users to share rich, customizable contact cards
      directly to device phonebooks. Whether it's for personal or professional
      use, Life empowers individuals to stay in touch with ease.
      <br />
      <br />
      As part of OnePIN, we are backed by a robust and proven infrastructure.
      OnePIN's software is embedded on more than 1 billion mobile devices across
      the globe and is deployed in partnership with leading mobile network
      operators worldwide. Our technology is protected by over 50 global
      patents, ensuring innovation and reliability at scale.
      <br />
      <br />
      At Life Technologies, we’re shaping the future of digital connection — one
      contact at a time.
    </>
  );
}
